import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getIntegrationGitDetails = (
  id: string,
  integrationName: string
): Promise<any> =>
  apiClient(`/v1/repo/${integrationName}/${id}/org/${getOrgId()}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const excludeBranches = (params: any): Promise<any> => {
  return apiClient(
    `/v1/repo/${params?.integrationName}/${params?.id2}/org/${getOrgId()}`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params?.data),
    }
  );
};
